export default __webpack_public_path__ + "static/media/roleta.b39310fc.mp3";